module.exports = __webpack_public_path__ + "static/th-ea3304f59997290c49b90167708127b9.png";